export default {
    paragraph: {}
}



// WEBPACK FOOTER //
// ./src/views/Offline/styles.js